import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef, useEffect } from 'react';
import { View, Text, TouchableOpacity, ScrollView, findNodeHandle } from 'react-native';
import { TabPanel } from './tabPanel';
import { halfWindowWidth } from './NestedTabs';
import styles from './styles';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
export var TabsType;
(function (TabsType) {
  TabsType["noUnderscore"] = "noUnderscore";
  TabsType["underscore"] = "underscore";
})(TabsType || (TabsType = {}));
var Tabs = function Tabs(props) {
  var titles = props.titles,
    _props$defaultSelecte = props.defaultSelected,
    defaultSelected = _props$defaultSelecte === void 0 ? 0 : _props$defaultSelecte,
    containerStyle = props.containerStyle,
    titleStyle = props.titleStyle,
    titleContainerStyle = props.titleContainerStyle,
    contentStyle = props.contentStyle,
    children = props.children,
    _props$type = props.type,
    type = _props$type === void 0 ? TabsType.noUnderscore : _props$type,
    onChange = props.onChange,
    componentTrackingData = props.componentTrackingData;
  var _useState = useState(defaultSelected),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var titlesScrollViewRef = useRef(null);
  var selectedTitleRef = useRef(null);
  useEffect(function () {
    setTimeout(function () {
      if (titlesScrollViewRef.current && selectedTitleRef.current) {
        selectedTitleRef.current.measureLayout(findNodeHandle(titlesScrollViewRef.current), function (x, _, width) {
          var _titlesScrollViewRef$, _titlesScrollViewRef$2;
          (_titlesScrollViewRef$ = titlesScrollViewRef.current) === null || _titlesScrollViewRef$ === void 0 ? void 0 : (_titlesScrollViewRef$2 = _titlesScrollViewRef$.scrollTo) === null || _titlesScrollViewRef$2 === void 0 ? void 0 : _titlesScrollViewRef$2.call(_titlesScrollViewRef$, {
            x: x - halfWindowWidth + width / 2,
            animated: false
          });
        });
      }
    });
  }, []);
  var handleChange = function handleChange(index, title) {
    if (index === selected || title.disabled) {
      return;
    }
    setSelected(index);
    onChange === null || onChange === void 0 ? void 0 : onChange(index);
  };
  var renderTitle = function renderTitle(title, index) {
    var _useComponentTracking = useComponentTracking({
        componentTrackingData: componentTrackingData,
        componentData: {
          title: title,
          index: index
        }
      }),
      tracker = _useComponentTracking.tracker,
      tabTracking = _useComponentTracking.result.tab;
    var props = {
      // Default tab to be visible
      ref: index === selected ? selectedTitleRef : undefined,
      style: [index === selected && styles.selected, title.disabled && styles.disabled],
      onPress: function onPress() {
        handleChange(index, title);
        (tabTracking === null || tabTracking === void 0 ? void 0 : tabTracking.trackingClick) && tracker.click(tabTracking.trackingClick);
      }
    };
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      key: title.name,
      onPress: props.onPress
    }, /*#__PURE__*/React.createElement(View, {
      ref: props.ref,
      style: type === TabsType.underscore && index === selected && styles.selectedWithUnderscore
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.tabsTitle, props.style, titleStyle]
    }, title.name)));
  };
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.tabsContainer, containerStyle]
  }, /*#__PURE__*/React.createElement(ScrollView, {
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    style: [styles.tabsTitleContainer, titleContainerStyle],
    ref: titlesScrollViewRef
  }, titles.map(function (title, index) {
    return renderTitle(title, index);
  })), /*#__PURE__*/React.createElement(View, {
    style: [styles.tabsContentContainer, contentStyle]
  }, React.Children.map(children, function (child, index) {
    // 优化见 NestedTabs
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.tabContent, index !== selected && {
        position: 'absolute',
        left: -9999
      }]
    }, child);
  })));
};
export { TabPanel, Tabs };